// components/toc.ts
import { isTouch } from '../utils';
import { lenis } from '../animations/scroll';

const slugify = (text: string): string => {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-');
};

export const init = (): void => {
    const pageType = document.body.dataset.type;
    if (pageType !== 'service' && pageType !== 'post') return;

    const grid = document.querySelector<HTMLElement>('.grid');
    if (!grid) return;

    const columns = grid.querySelectorAll<HTMLElement>(':scope > .column');
    if (columns.length < 2) return;

    const summaryColumn = columns[0];
    const contentColumn = columns[1];

    const summary = summaryColumn.querySelector<HTMLElement>('.post-summary');
    if (!summary) return;

    const firstLevel = contentColumn.querySelector('h2') ? 'h2' : 'h3';
    const headings = contentColumn.querySelectorAll<HTMLElement>(firstLevel);
    if (!headings.length) return;

    const ul = document.createElement('ul');

    headings.forEach((heading, index) => {
        if (!heading.id) {
            heading.id = slugify(heading.textContent || `section-${index}`);
        }

        const li = document.createElement('li');
        const a = document.createElement('a');

        a.textContent = heading.textContent || '';
        a.href = `${location.pathname}#${heading.id}`;

        if (heading.tagName === 'H3') {
            li.classList.add('is-sub');
        }

        a.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();

            if (isTouch()) {
                heading.scrollIntoView({ behavior: 'smooth' });
                return;
            }

            const headerOffset = parseInt(
                getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '100',
                10
            );

            lenis.scrollTo(heading, {
                offset: -headerOffset - 20,
                duration: 0.8,
            });
        });

        li.appendChild(a);
        ul.appendChild(li);
    });

    summary.appendChild(ul);

    if (!isTouch()) {
        setupActiveLink(headings, ul);
    }
};

const setupActiveLink = (
    headings: NodeListOf<HTMLElement>,
    ul: HTMLElement
): void => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    ul.querySelectorAll<HTMLAnchorElement>('a').forEach((link) => link.classList.remove('is-active'));
                    ul.querySelector<HTMLAnchorElement>(`a[href="${location.pathname}#${entry.target.id}"]`)?.classList.add('is-active');
                }
            });
        },
        { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );

    headings.forEach((h) => observer.observe(h));
};
